const users =
{
    helmet :
    {
        title : 'Utilisateurs' ,
        metas : []
    }
};

export default users ;